import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import BootstrapVue from "bootstrap-vue";
import { BootstrapVueIcons } from "bootstrap-vue";
import Toast from "vue-toastification";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "vue-toastification/dist/index.css";

Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(Toast);

// axios.defaults.baseURL = "http://localhost:3000"; // Replace with your API

const token = localStorage.getItem("token"); // Retrieve token from localStorage

if (token) {
  axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
}

axios.defaults.baseURL = "https://postmate.introvertweb.com/backend"; // Replace with your API

await store.dispatch("initializeStore");

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
